
<template>
  <div id="allprint" style="width: 100%;position:absolute" v-loading="loading" element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.5)">

    <div class="deviceInfo">
      <div class="deviceInfo-header">
        <div>计划详情</div>
      </div>
      <div class="deviceInfo-content disFlex">
        <div>
          <table class="boughtTable">
            <tr>
              <td class="boughtTd1">标题</td>
              <td colspan="5">{{planInfo.planname}}</td>
            </tr>
            <tr>
              <td class="boughtTd1">培训类别</td>
              <td>{{planInfo.itype==1?'线上培训':'线下培训'}}</td>
              <td class="boughtTd1">课时</td>
              <td>{{planInfo.littletime}}</td>
              <td class="boughtTd1">培训人数</td>
              <td>{{planInfo.pnum}}</td>
            </tr>
            <tr>
              <td class="boughtTd1">有效期</td>
              <td colspan="5">{{planInfo.endtime}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="deviceInfo" v-if="planInfo.itype==2">
      <div class="deviceInfo-header">
        培训文件
      </div>
      <div class="deviceInfo-content disFlex">
        <div>
          <div v-for="(item,i) in fileList" :key="i" style="margin-bottom: 10px;">
            <el-link icon="el-icon-view" type="primary" :href="item.url" target="_blank">
              {{item.name}}
            </el-link>
          </div>
          <!-- <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
            :file-list="fileList">
          </el-upload> -->
        </div>
      </div>
    </div>

    <div class="deviceInfo" v-if="planInfo.itype=='1'">
      <div class="deviceInfo-header between">
        <div>关联课程信息</div>
      </div>
      <div class="deviceInfo-content kctable">

        <table class="printTable">
          <thead>
            <tr>
              <th width="100" align="center">封面</th>
              <th align="center">名称</th>
              <th width="180" align="center">课程类别</th>
              <th width="120" align="center">总课时</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in planInfo.ktProductPlanList">
              <td align="center"><img :src="wjSrc+item.img" style="width: 52px;height: 31px;border-radius: 3px;" /></td>
              <td align="center">{{item.productname}}</td>
              <td align="center">{{item.itypeName}}</td>
              <td align="center">{{item.allxstime}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="deviceInfo" v-if="planInfo.itype=='1'">
      <div class="deviceInfo-header between">
        <div>学员信息</div>
      </div>
      <div class="deviceInfo-content xytable">
        <table class="printTable">
          <thead>
            <tr>
              <th align="center" width="100">头像</th>
              <th  align="center" width="120">名称</th>
              <th  align="center" width="120">手机号</th>
              <th align="center"  width="200">部门</th>
              <th align="center"  width="180">岗位</th>
              <th align="center" width="80">性别</th>
              <th align="center" style="width: 25vw;">学习状态</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in planInfo.ktUserPlanlist">
              <td align="center"><el-avatar size="medium" :src="getTxurl(item)"></el-avatar></td>
              <td align="center">{{item.realName}}</td>
              <td align="center">{{item.phone}}</td>
              <td align="center">{{item.orgName}}</td>
              <td align="center">{{item.gwName}}</td>
              <td align="center">{{item.sex}}</td>
              <td>
                <div class="xuexizhuangt">
                  <div class="likeSatrt">
                    <div :style="'width:'+item.xxbfb+'%'"></div>
                  </div>
                  <div class="disFlex between">
                    <div>已学:<span style="color: #0071BA;">{{item.yxkcnum}}</span>/{{item.jhkcnum}}</div>
                    <div>学习总时长：{{item.xxztime}}小时</div>
                    <div>{{item.xxbfb}}%</div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('联系方式不能为空！'));
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(value))) {
          callback(new Error('联系方式有误，请重新输入！'));
        } else {
          callback();
        }
      };
      return {
        circleUrl: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
        keyIndex: parseInt(Math.random() * 1000),
        formInline: {
          keyword: '',
          kstate: '',
          rows: 100,
          page: 1
        },
        loading: true,
        wjSrc: '',
        newUserlist: [],
        planInfo: {
          ktUserPlanlist: []
        },
        tableData: {
          rows: [],
          total: 0
        },
        txnanUrl: require('@/assets/images/notxnan.png'),
        txnvUrl: require('@/assets/images/notxnv.png'),
        txnoUrl: require('@/assets/images/nosex.png'),
        txadminUrl: require('@/assets/images/notxsex.png'),
        fileList: []
      }
    },
    methods: {
      getData: function(id) {
        this.$axios.get('/kt/ktProductLeanplan/detail.htm?id=' + id).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.planInfo = data.data;
            var fileList = data.data.filestr ? JSON.parse(data.data.filestr) : [];
            this.fileList = fileList.map((item) => {
              return {
                ...item,
                id: item.fileid,
                url: this.wjSrc + item.filepath
              }
            });
            this.newUserlist = data.data.ktUserPlanlist;
            var $this = this;
            setTimeout(function() {
              $this.print();
            }, 800)

          } else {
            this.$message.error(data.message);
          }
        })
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      getTxurl: function(item) {
        if (item.avatarurl) {
          return this.wjSrc + item.avatarurl
        } else if (item.sex == '女') {
          return this.txnvUrl
        } else if (item.sex == '男') {
          return this.txnanUrl
        } else if (item.roleCode == "COM_ADMIN_AQKT") {
          return this.txadminUrl
        } else {
          return this.txnoUrl
        }
      },
      print: function() {
        var imgs = $('#allprint').find('img').length;
        var $this=this;
        if (imgs) {
          if (imgs > 5) {
            setTimeout(function() {
              $this.loading = false;
              setTimeout(function() {
                $('#allprint').print();
                window.close();
              }, 500)
            }, 4500)
          } else {
            setTimeout(function() {
              $this.loading = false;
              setTimeout(function() {
                $('#allprint').print();
                window.close();
              }, 500)
            }, 800)
          }
        } else {
          setTimeout(function() {
            $this.loading = false;
            setTimeout(function() {
              $('#allprint').print();
              window.close();
            }, 500)
          }, 800)

        }
      }
    },
    created: function() {
      var url = "";
      //108网  crm
      if (window.location.host.indexOf('demo.tsanquan.com') != '-1') {
        url = 'http://dstatic.tsanquan.com';
      } else if (window.location.host.indexOf('localhost') != '-1') {
        url = 'http://192.168.0.108:8082/jtzy';
      } else {
        url = window.location.origin + '/jtzy';
      };
      this.wjSrc = url
      // 计划详情
      if (this.$route.query.id) {
        this.getData(this.$route.query.id)
      };
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getSearchData();
        },
        deep: true //true 深度监听
      }
    },
  }
</script>
<style>
  /* 打印时不显示 */
  @media print {
    @page {
      /* 默认横向打印 */
      size: landscape;
      margin: 0mm;
    }

    body {
      -webkit-print-color-adjust: exact;
      -moz-print-color-adjust: exact;
      -ms-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    .notPrint {
      display: none;
    }

    .el-table {
      width: 50vw !important;
    }
  }

  .deviceInfo {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    margin-top: 20px;
  }

  .deviceInfo-header {
    height: 70px;
    border-bottom: 1px solid #efefef;
    padding: 0 30px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333333;
    font-size: 16px;
    font-weight: 500;
  }

  .deviceInfo-content {
    padding: 20px;
  }

  .boughtTable {
    line-height: 38px;
    text-align: left;
    font-size: 14px;
  }

  .boughtTable td {
    padding-left: 20px;
    width: 16vw;
    border: 1px solid #efefef;
  }
  .printTable{
    text-align: left;
    font-size: 14px;
  }
  .printTable th,td {
    padding: 12px;
    border: 1px solid #efefef;
  }
  .printTable th{
    background-color: #f6f6f6;
  }

  .boughtTd1 {
    height: 38px;
    background-color: #f6f6f6;
    width: 105px;
  }

  .likeSatrt {
    height: 6px;
    opacity: 1;
    background: #f5f5f5;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .likeSatrt div {
    background-color: #0071BA;
    height: 6px;
    opacity: 1;
    border-radius: 8px;
    width: 50%;
  }

  .xuexizhuangt {
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: right;
    color: #8c8c8c;
  }

  .kctable .el-table th {
    background-color: #EFEFEF;
  }

  .kctable .el-table td {
    background-color: #F6F6F6;
  }

  .xytable .el-table th {
    background-color: #FAFAFA;
  }
</style>



// WEBPACK FOOTER //
// src/components/printPlaninfo.vue